import { apiTrpcReact } from "./apiTrpcReact";

export { apiTrpcClient } from "./apiTrpcClient";
export default apiTrpcReact;
